module.exports = __webpack_public_path__ + "img/boshu_catch_sp.7fe79bb3.jpg";